export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    getAdditionalTableConfig: state => state.additionalTableConfig,
    getSearchFields: state => state.searchFields
}
